import { EditTwoTone } from "@ant-design/icons";
import { apiStatuses } from "@/store/api/constants";
import { IconButton, Stack, Tooltip } from "@mui/material";
import PropTypes from 'prop-types';
 
function EditAction({row, onRowEdit }) {
    const {original: {id}} = row; 
    return (
    <Stack direction="row" spacing={1} alignItems="center">
        <Tooltip title="Edit">
            <IconButton
                color="primary"
                onClick={() => onRowEdit(id) }
                // disabled={deleteFillBagStatus === apiStatuses.pending}
            >
                <EditTwoTone />
            </IconButton>
        </Tooltip>
    </Stack>
    );
}

EditAction.propTypes = {
    row: PropTypes.object,
    table: PropTypes.object,
    options: PropTypes.array,
    id: PropTypes.number,
    index: PropTypes.number
};
export default EditAction;
